import React from 'react';
import { Box, Typography } from '@mui/material';
import useListaConversasHook from './useListaConversasHook';
import './styles.scss';

/**
 * Conversas recentes do usuario, em painel que desliza sob o cabecalho.
 *
 * O backend ja devolve apenas as conversas do proprio usuario e apenas as
 * ativas (ChatIaService::listarConversas), entao nao ha filtro de escopo aqui.
 */
export default function ListaConversas({ conversas, uuidAtivo, aoSelecionar }) {
  const { formatarTempoRelativo } = useListaConversasHook();

  return (
    <Box className="chat-ia-lista-conversas">
      <Typography className="chat-ia-lista-conversas-rotulo">Conversas recentes</Typography>

      <Box className="chat-ia-lista-conversas-itens">
        {conversas.map(conversa => {
          const ativa = conversa.uuid === uuidAtivo;

          return (
            <Box
              key={conversa.uuid}
              className={`chat-ia-conversa ${ativa ? 'chat-ia-conversa-ativa' : ''}`}
              onClick={() => aoSelecionar(conversa.uuid)}
              role="button"
              tabIndex={0}
              onKeyDown={evento => {
                if (evento.key === 'Enter' || evento.key === ' ') {
                  evento.preventDefault();
                  aoSelecionar(conversa.uuid);
                }
              }}
            >
              <span className="chat-ia-conversa-marcador" aria-hidden="true" />
              <Typography className="chat-ia-conversa-titulo" noWrap>
                {conversa.titulo || 'Conversa sem título'}
              </Typography>
              <Typography className="chat-ia-conversa-tempo">
                {formatarTempoRelativo(conversa.ultima_mensagem_em ?? conversa.criada_em)}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
